
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("ekO4Z", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $adfd33f544282edc$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8YEE2 = parcelRequire("8YEE2");

var $dsVYa = parcelRequire("dsVYa");

var $ieDtd = parcelRequire("ieDtd");
var $doZTA = parcelRequire("doZTA");

var $eOD4f = parcelRequire("eOD4f");
/**
 * Manages the visibility and state of the project builder drawer based on query parameters.
 * It controls when to show the project builder drawer, especially after a condition
 * involving specific query parameters is met, ensuring it's not displayed for auto-created
 * projects or outside the project queues page. This component also handles the drawer's
 * open state and its closure action.
 */ const $adfd33f544282edc$var$ProjectBuilderWithQueryParam = ()=>{
    const [projectBuilderQueryParam, setProjectBuilderQueryParam] = (0, $ieDtd.useQueryParam)((0, $dsVYa.SHOW_PROJECT_BUILDER_QUERY_PARAM));
    // if it's a first, auto created, JSM project as part of X-flow from JSW
    const [autoCreateFirstJsmProject] = (0, $ieDtd.useQueryParam)('autoCreateFirstJsmProject');
    const [{ route: route }] = (0, $doZTA.useRouter)();
    const [state, actions] = (0, $eOD4f.useProjectBuilder)();
    const onClosed = (0, $5uXOq.useCallback)(()=>{
        actions.hideProjectBuilder();
    }, [
        actions
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // Show project builder only on project queues page, but not on auto-created projects
        if (projectBuilderQueryParam === 'true' && autoCreateFirstJsmProject !== '1' && (route.name === 'servicedesk-queues-landing' || route.name === 'servicedesk-getting-started-page')) {
            actions.showProjectBuilder();
            setProjectBuilderQueryParam(undefined);
        }
    }, [
        actions,
        autoCreateFirstJsmProject,
        projectBuilderQueryParam,
        route.name,
        setProjectBuilderQueryParam
    ]);
    if (state.isProjectBuilderOpen) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8YEE2.AsyncProjectBuilderDrawer), {
        isOpenInitial: true,
        onClosed: onClosed
    });
    return null;
};
var $adfd33f544282edc$export$2e2bcd8739ae039 = $adfd33f544282edc$var$ProjectBuilderWithQueryParam;

});
parcelRegister("8YEE2", function(module, exports) {

$parcel$export(module.exports, "LazyComponent", () => $300188a98a9fded7$export$31f1740ae531af94);
$parcel$export(module.exports, "AsyncProjectBuilderDrawer", () => $300188a98a9fded7$export$54a4eade9eae9473);
$parcel$export(module.exports, "canUseProjectBuilder", () => $300188a98a9fded7$export$ff317c5d87147a19);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");

var $9noxX = parcelRequire("9noxX");

var $kxZPA = parcelRequire("kxZPA");

const $300188a98a9fded7$export$31f1740ae531af94 = (0, $kxZPA.lazy)(()=>(parcelRequire("g4q97")), {
    ssr: false,
    moduleId: "./src/packages/servicedesk/project-builder/src/ui/index.tsx"
});
const $300188a98a9fded7$export$54a4eade9eae9473 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "bundle-async-project-builder",
        packageName: "jira-servicedesk-project-builder",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        fallback: null,
        name: "jsm-project-builder"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9noxX.ServiceDeskAnalyticsContext), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($300188a98a9fded7$export$31f1740ae531af94, {
        isOpenInitial: !!props.isOpenInitial,
        ...props
    }))));
const $300188a98a9fded7$export$ff317c5d87147a19 = (isAdmin)=>isAdmin;

});
parcelRegister("9noxX", function(module, exports) {

$parcel$export(module.exports, "ServiceDeskAnalyticsContext", () => $12b9024f66e7ef57$export$ac31f8f3368d6881);

var $5uXOq = parcelRequire("5uXOq");

var $iXVV6 = parcelRequire("iXVV6");

var $4DPZY = parcelRequire("4DPZY");

var $8H3A4 = parcelRequire("8H3A4");
const $12b9024f66e7ef57$export$ac31f8f3368d6881 = ({ useContainerContext: useContainerContext, useServiceDeskAnalyticsContext: useServiceDeskAnalyticsContext, children: children, forceRenderWhileLoading: forceRenderWhileLoading })=>{
    const [{ data: containerContextData, loading: containerContextLoading }] = useContainerContext();
    const { data: analyticsContextAttributes, error: analyticsContextError, loading: analyticsContextLoading } = useServiceDeskAnalyticsContext();
    if ((0, $5uXOq.Children).count(children) > 0) {
        const loading = containerContextLoading || analyticsContextLoading;
        const shouldRenderChildren = !loading || loading && forceRenderWhileLoading || !!analyticsContextError;
        if (!shouldRenderChildren) return null;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const context = {};
        // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'.
        if (containerContextData && containerContextData.project) {
            // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'.
            const { id: id, type: type } = containerContextData.project;
            // containerType and containerId are obsolete - See https://developer.atlassian.com/platform/analytics-pipeline/getting-started/event-types/#glossary-of-terms
            // Also these dont work with screen events. See sendScreenEvent in: https://bitbucket.org/atlassian/analytics-web-client/src/master/src/analyticsWebClient.js
            // However they are kept here to not break any existing usages.
            context.containerType = 'project';
            context.containerId = `${id}`;
            // This is the preferred way to send container data for analytics
            context.containers = {
                project: {
                    id: `${id}`,
                    type: type
                }
            };
            if (analyticsContextAttributes && !analyticsContextError) context.attributes = analyticsContextAttributes;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), context, children);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
};
$12b9024f66e7ef57$export$ac31f8f3368d6881.defaultProps = {
    forceRenderWhileLoading: false,
    useServiceDeskAnalyticsContext: (0, $8H3A4.useServiceDeskAnalyticsContext),
    useContainerContext: (0, $4DPZY.useContainerContext)
};

});
parcelRegister("4DPZY", function(module, exports) {

$parcel$export(module.exports, "useContainerContext", () => $a65e0c39573f7437$export$c7066c2d215990cf);
$parcel$export(module.exports, "ContainerContextSubscriber", () => $a65e0c39573f7437$export$5b87a78c45d5dd17);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $7xTO3 = parcelRequire("7xTO3");

var $ggg5j = parcelRequire("ggg5j");

var $2YP9W = parcelRequire("2YP9W");

var $6SkQo = parcelRequire("6SkQo");
const $a65e0c39573f7437$var$useProjectContext = ()=>{
    const { data: data, loading: loading, error: error, refresh: refresh } = (0, $2YP9W.useResource)((0, $ggg5j.staticProjectSidebarNavigationResource));
    const projectContext = (0, $5uXOq.useMemo)(()=>data && (0, $6SkQo.getProjectContext)(data), [
        data
    ]);
    return [
        {
            data: projectContext,
            error: error,
            loading: loading
        },
        {
            fetch: refresh,
            refetch: refresh
        }
    ];
};
const $a65e0c39573f7437$var$useUserBoardContext = ()=>{
    const { data: data, loading: loading, error: error, refresh: refresh } = (0, $2YP9W.useResource)((0, $7xTO3.staticJSWUserBoardSidebarNavigationResource));
    const userContext = (0, $5uXOq.useMemo)(()=>data && (0, $6SkQo.getUserContext)(data), [
        data
    ]);
    return [
        {
            data: userContext,
            error: error,
            loading: loading
        },
        {
            fetch: refresh,
            refetch: refresh
        }
    ];
};
const $a65e0c39573f7437$export$c7066c2d215990cf = ()=>{
    const projectContext = $a65e0c39573f7437$var$useProjectContext();
    const userBoardContext = $a65e0c39573f7437$var$useUserBoardContext();
    if (userBoardContext && userBoardContext[0] && userBoardContext[0].data != null) return userBoardContext;
    return projectContext;
};
const $a65e0c39573f7437$export$5b87a78c45d5dd17 = (props)=>{
    const [data, actions] = $a65e0c39573f7437$export$c7066c2d215990cf();
    // @ts-expect-error - TS2345 - Argument of type '{ readonly data: ContainerContext | null; readonly error: Error | Record<string, any> | (Error & Record<string, any>) | (Record<string, any> & Error) | null; readonly loading: boolean; }' is not assignable to parameter of type 'ContainerContextData'.
    return props.children(data, actions);
};
$a65e0c39573f7437$export$5b87a78c45d5dd17.displayName = 'ContainerContextSubscriber';

});
parcelRegister("6SkQo", function(module, exports) {

$parcel$export(module.exports, "getUserContext", () => $84cf60e2c9c0e289$export$114c35c2c23732ab);
$parcel$export(module.exports, "getProjectContext", () => $84cf60e2c9c0e289$export$d17fffd59c7b3c60);

var $4R6GH = parcelRequire("4R6GH");

var $2vSU6 = parcelRequire("2vSU6");

var $bsuuc = parcelRequire("bsuuc");
const $84cf60e2c9c0e289$export$114c35c2c23732ab = (userBoardNavData)=>{
    const { boardInfo: boardInfo, owner: owner } = userBoardNavData;
    return {
        contextType: 'user',
        user: {
            id: owner.id,
            name: owner.name,
            avatarUrl: owner.avatarUrl,
            profileUrl: owner.profileUrl,
            accountId: owner.accountId
        },
        scope: {
            id: boardInfo.id,
            type: boardInfo.type,
            name: boardInfo.name
        }
    };
};
const $84cf60e2c9c0e289$var$getScope = (projectNavInfo)=>{
    if (projectNavInfo.projectType === 'jira_software' && projectNavInfo?.jiraSoftwareNavData?.boardInfo) {
        const { boardInfo: boardInfo } = projectNavInfo.jiraSoftwareNavData;
        return {
            id: boardInfo.id,
            type: boardInfo.type,
            name: boardInfo.name
        };
    }
    return undefined;
};
const $84cf60e2c9c0e289$var$getProjectType = (projectType)=>{
    if (projectType === 'customer_service' && (0, $4R6GH.fg)('jcs_project_type_m3')) return 0, $2vSU6.CUSTOMER_SERVICE_PROJECT;
    switch(projectType){
        case 'business':
            return 0, $2vSU6.CORE_PROJECT;
        case 'software':
            return 0, $2vSU6.SOFTWARE_PROJECT;
        case 'service_desk':
            return 0, $2vSU6.SERVICE_DESK_PROJECT;
        case 'product_discovery':
            return 0, $2vSU6.PRODUCT_DISCOVERY_PROJECT;
        default:
            return null;
    }
};
const $84cf60e2c9c0e289$export$d17fffd59c7b3c60 = (projectNavInfo)=>{
    const project = (0, $bsuuc.extractData)(projectNavInfo);
    const scope = $84cf60e2c9c0e289$var$getScope(projectNavInfo);
    if (project) {
        const projectType = $84cf60e2c9c0e289$var$getProjectType(project.type);
        if (projectType) return {
            contextType: 'project',
            project: {
                key: project.key,
                // @ts-expect-error TS2322: Type 'number' is not assignable to type 'string'
                id: project.id,
                name: project.name,
                type: projectType,
                isSimplified: project.isSimplified,
                avatarUrl: project.avatarUrl,
                style: (0, $bsuuc.getStyle)(project.isSimplified)
            },
            scope: scope
        };
    }
    return null;
};

});



parcelRegister("g4q97", function(module, exports) {

let $bb314d24af04bc80$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $bb314d24af04bc80$var$load("kVX56"),
    $bb314d24af04bc80$var$load("kNFvF"),
    $bb314d24af04bc80$var$load("ffQaD"),
    $bb314d24af04bc80$var$load("kvRbA"),
    $bb314d24af04bc80$var$load("3yAl4"),
    $bb314d24af04bc80$var$load("jbxE1"),
    $bb314d24af04bc80$var$load("7imUH"),
    $bb314d24af04bc80$var$load("76n7a"),
    $bb314d24af04bc80$var$load("l253H"),
    $bb314d24af04bc80$var$load("14MdE")
]).then(()=>parcelRequire('c9lEE'));

});


parcelRegister("dsVYa", function(module, exports) {

$parcel$export(module.exports, "SHOW_PROJECT_BUILDER_QUERY_PARAM", () => $570185105586d012$export$ca06930325b64075);
$parcel$export(module.exports, "SHOW_PROJECT_BUILDER_QUERY_PARAM_DEV", () => $570185105586d012$export$bdaa4b82186a5b44);
$parcel$export(module.exports, "BLANK_PROJECT_TEMPLATES", () => $570185105586d012$export$26b62c0869751109);
const $570185105586d012$export$ca06930325b64075 = 'showProjectBuilder';
const $570185105586d012$export$bdaa4b82186a5b44 = 'showProjectBuilderDev';
const $570185105586d012$export$26b62c0869751109 = [
    'com.atlassian.servicedesk:simplified-blank-project-it',
    'com.atlassian.servicedesk:simplified-blank-project-business',
    'com.atlassian.servicedesk:company-managed-blank-service-project',
    'com.atlassian.servicedesk:team-managed-blank-service-project'
];

});

parcelRegister("eOD4f", function(module, exports) {

$parcel$export(module.exports, "useProjectBuilder", () => $06ebb99a27f60c8b$export$5891129c2551a3c0);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $06ebb99a27f60c8b$var$ProjectBuilderStore = (0, $iXqE5.createStore)({
    initialState: {
        isProjectBuilderOpen: false
    },
    actions: {
        hideProjectBuilder: ()=>({ setState: setState })=>{
                setState({
                    isProjectBuilderOpen: false
                });
            },
        showProjectBuilder: ()=>({ setState: setState })=>{
                setState({
                    isProjectBuilderOpen: true
                });
            }
    },
    name: 'projectBuilder'
});
const $06ebb99a27f60c8b$export$5891129c2551a3c0 = (0, $3sQ5x.createHook)($06ebb99a27f60c8b$var$ProjectBuilderStore);

});



//# sourceMappingURL=async-service-project-builder.8fa5f108.js.map
